/**
 * Computes the horizontal scroll percentage of an element based on its scroll width and client width.
 * @param scrollWidth element scroll width
 * @param clientWidth element client width
 * @param step step to round the result to (default is 0.1 for 10% increments)
 * @param rangeMax maximum output value
 * @returns horizontal scroll percentage
 */
export function computeScrollPercent(
  scrollWidth: number,
  clientWidth: number,
  step: number = 1,
  rangeMax: number = 100,
): number {
  if (scrollWidth <= clientWidth) return 0;

  const ratio: number = (scrollWidth - clientWidth) / scrollWidth;
  const smoothed: number = ratio * rangeMax;

  return step > 0 ? Math.ceil(smoothed / step) * step : smoothed;
}
